import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import _toConsumableArray from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _defineProperty from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { axiosInstance } from 'boot/axios.js';
export function query(_x) {
  return _query.apply(this, arguments);
}

function _query() {
  _query = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/products',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            return _context.abrupt("return", _context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _query.apply(this, arguments);
}

export function recommended(_x2) {
  return _recommended.apply(this, arguments);
}

function _recommended() {
  _recommended = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        response,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: '/recommend-products',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context2.sent;
            ctx.commit('recommended', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            return _context2.abrupt("return", response);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.error(_context2.t0);
            return _context2.abrupt("return", _context2.t0);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return _recommended.apply(this, arguments);
}

export function queryWithOutlet(_x3) {
  return _queryWithOutlet.apply(this, arguments);
}

function _queryWithOutlet() {
  _queryWithOutlet = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(ctx) {
    var queryParams,
        page,
        sort,
        _queryParams,
        products,
        hasQueryParams,
        outlet,
        items,
        itemsPerPage,
        total,
        lastPage,
        pagination,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.prev = 1;
            page = queryParams.page ? queryParams.page : 1;
            sort = queryParams.sort ? queryParams.sort : '';
            _queryParams = Object.assign({}, queryParams);
            delete _queryParams.page;
            delete _queryParams.sort;
            delete _queryParams.type;
            products = {};
            hasQueryParams = Object.keys(_queryParams).length !== 0;

            if (!hasQueryParams) {
              _context3.next = 14;
              break;
            }

            _context3.next = 13;
            return axiosInstance({
              url: '/products',
              params: _objectSpread({}, _queryParams, {
                limit: 10000
              }),
              method: 'GET'
            });

          case 13:
            products = _context3.sent;

          case 14:
            _context3.next = 16;
            return axiosInstance({
              url: '/products-outlet',
              params: {
                limit: 10000
              },
              method: 'GET'
            });

          case 16:
            outlet = _context3.sent;
            items = outlet.data.items;

            if (hasQueryParams) {
              items = [].concat(_toConsumableArray(items), _toConsumableArray(products.data.items));
            }

            if (sort === '' || sort === 'name ASC') {
              items.sort(function (a, b) {
                if (a.name > b.name) {
                  return 1;
                }

                if (a.name < b.name) {
                  return -1;
                }

                return 0;
              });
            } else if (sort === 'price ASC') {
              items.sort(function (a, b) {
                if (a.price > b.price) {
                  return 1;
                }

                if (a.price < b.price) {
                  return -1;
                }

                return 0;
              });
            }

            itemsPerPage = items.slice(page * 15 - 15, page * 15);
            total = parseInt(outlet.data.pagination.total);

            if (hasQueryParams) {
              total += parseInt(products.data.pagination.total);
            }

            lastPage = Math.ceil(total / 15);
            pagination = {
              lastPage: lastPage,
              page: page,
              perPage: 15,
              total: total
            };
            ctx.commit('items', itemsPerPage);
            ctx.commit('pagination', pagination);
            _context3.next = 32;
            break;

          case 29:
            _context3.prev = 29;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", _context3.t0);

          case 32:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 29]]);
  }));
  return _queryWithOutlet.apply(this, arguments);
}

export function paginationWithOutlet(_x4) {
  return _paginationWithOutlet.apply(this, arguments);
}

function _paginationWithOutlet() {
  _paginationWithOutlet = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(ctx) {
    var queryParams,
        products,
        outlet,
        items,
        itemsPerPage,
        total,
        lastPage,
        pagination,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            queryParams = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _context4.prev = 1;
            _context4.next = 4;
            return axiosInstance({
              url: '/products',
              params: _objectSpread({}, queryParams, {
                limit: 10000
              }),
              method: 'GET'
            });

          case 4:
            products = _context4.sent;
            _context4.next = 7;
            return axiosInstance({
              url: '/products-outlet',
              params: {
                limit: 10000
              },
              method: 'GET'
            });

          case 7:
            outlet = _context4.sent;
            items = [].concat(_toConsumableArray(products.data.items), _toConsumableArray(outlet.data.items));
            items.sort(function (a, b) {
              if (a.name > b.name) {
                return 1;
              }

              if (a.name < b.name) {
                return -1;
              }

              return 0;
            });
            itemsPerPage = items.slice(0, 15);
            total = parseInt(products.data.pagination.total) + parseInt(outlet.data.pagination.total);
            lastPage = Math.ceil(total / 15);
            pagination = {
              lastPage: lastPage,
              page: 1,
              perPage: 15,
              total: total
            };
            ctx.commit('items', itemsPerPage);
            ctx.commit('pagination', pagination);
            _context4.next = 21;
            break;

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", _context4.t0);

          case 21:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 18]]);
  }));
  return _paginationWithOutlet.apply(this, arguments);
}

export function get(_x5) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(ctx) {
    var queryParams,
        response,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            _context5.prev = 1;
            _context5.next = 4;
            return axiosInstance({
              url: parseUrl('products', queryParams),
              method: 'GET'
            });

          case 4:
            response = _context5.sent;
            ctx.commit('item', response.data);
            return _context5.abrupt("return", response);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", _context5.t0);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 9]]);
  }));
  return _get.apply(this, arguments);
}

function parseUrl(state, params) {
  if (state && params.id) {
    return "/".concat(state, "/").concat(params.id);
  }

  return "/".concat(state);
}